/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Composer_HintInputs */



/**
* | output |
* | --- |
* | "Enter to send · Shift+Enter for a new line" |
*
* @param {Assistant_Composer_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_composer_hint = /** @type {((inputs?: Assistant_Composer_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Composer_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appuyez sur Entrée pour envoyer · Maj+Entrée pour un saut de ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Senden die Eingabetaste drücken · Umschalt+Eingabetaste für eine neue Zeile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio per inviare · Maiusc+Invio per andare a capo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите Enter для отправки · Нажмите Shift+Enter для переноса строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca para enviar · Mayús+Intro para una nueva línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按 Enter 键发送 · 按 Shift+Enter 键换行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Enterキーで送信 · Shift+Enterで改行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भेजने के लिए एंटर दबाएं · नई पंक्ति के लिए Shift+Enter दबाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pressione Enter para enviar · Shift+Enter para uma nova linha")
	return /** @type {LocalizedString} */ ("Enter to send · Shift+Enter for a new line")
});